import type React from "react";
import type { ReactNode } from "react";
import { Box } from "../Box/Box";
import {
  type ResponsiveRangeProps,
  resolveResponsiveRangeProps,
} from "../utils/responsiveRangeProps";

export interface HiddenProps extends ResponsiveRangeProps {
  children: ReactNode;
  screen?: boolean;
  print?: boolean;
  inline?: boolean;
}

export const Hidden = ({
  children,
  above,
  below,
  screen,
  print,
  inline,
}: HiddenProps): React.ReactNode => {
  const hiddenOnScreen = Boolean(screen);
  const hiddenOnPrint = Boolean(print);

  const [hiddenOnMobile, hiddenOnTablet, hiddenOnDesktop] =
    resolveResponsiveRangeProps({ above, below });

  const display = inline ? "inline" : "block";

  return (
    <Box
      display={
        hiddenOnScreen
          ? "none"
          : [
              hiddenOnMobile ? "none" : display,
              hiddenOnTablet ? "none" : display,
              hiddenOnDesktop ? "none" : display,
            ]
      }
      className={hiddenOnPrint ? "hidden-on-print" : undefined}
      component={inline ? "span" : "div"}
    >
      {children}
    </Box>
  );
};
